import { observer } from 'mobx-react';
import ApplyViewModel from './ApplyViewModel';
import { useParams } from 'react-router-dom';
import useAsyncEffect from 'use-async-effect';
import { Steps } from './ApplyModels';
import { Button, InputOptionBox } from '../../../../core/components/Index';
import { Appl } from '../../../../core/Appl';
import Helper from '../../../../core/services/Helper';

const ServiceRetirementSignOff = observer(() => {

  const vm = Appl.Services.get<ApplyViewModel>('ApplyViewModel');
  let { memberId } = useParams();
  useAsyncEffect(async () => {
    await vm.loadStepAsync(Steps.ServiceRetirementSignOff, memberId!);
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-32px tracking--1percent text-neutral-800 font-semibold mb-4">Service Retirement Sign-Off</h1>
      </div>
      {/* {!vm.signOffModelCompleted && */}
      <>
        <p className="text-black text-15px tracking--1percent leading-26px">
          SCERS recognizes the significant value of retirement benefits provided to eligible employees and reminds retiring members that many benefit decisions are irrevocable. SCERS tries to develop processes that help members make informed decisions about retirement. Part of the process is to provide retiring members with a sign-off form to review and initial prior to the payment of any retirement benefits by SCERS.          </p>
        <p className="text-black text-15px tracking--1percent leading-26px">
          The form below memorializes your understanding of the information provided. Please initial each of the items listed by checking the box; this indicates an understanding of the item. If you have any questions regarding any of the items below, please speak with a retirement benefits staff member. This form will become a permanent part of your retirement file.</p>
        <div className="space-y-4">
          {vm.model.signOffModels.map((signOffModel, index) => (
            <div key={`signOffModel-div${index}`} className="flex space-x-0">
              <InputOptionBox
                inputId={`signOffModel${index}`}
                checked={signOffModel.active!}
                onChange={(e) => {
                  vm.onSignOffCheckboxChange(e, signOffModel, `active`);
                }}
                className=' -mt-[0px]'
              />
              <div className="ml-2 -mt-0 text-black text-15px">
                <label htmlFor={`signOffModel${index}`} className="mt-[1px] flex flex-col cursor-pointer px-4 pb-1 rounded-xl text-15px font-bold group"><span className=''>{signOffModel.lovServiceSignOffCd} </span>
                  <span className="font-normal mt-1">{Helper.formattedHtml(signOffModel.lovServiceSignOffDesc!)}</span></label>
              </div>
            </div>
          ))}
        </div>
        <div className="flex space-x-4 mt-6">
          <Button label='Save & Continue' rounded
            onClick={async () => await vm.onServiceRetirementSignOffStepCompletedAsync()}
            disabled={vm.model.signOffModels.filter(o => !o.active).length !== 0}
          />

        </div>
      </>
    </div>
  );
});

export default ServiceRetirementSignOff;
